var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.classButton,attrs:{"type":"button"},on:{"click":function($event){_vm.showHiddenFields = !_vm.showHiddenFields}}},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")]),_vm._v(" "),_c('div',{class:_vm.classContent},[(_vm.showHiddenFields)?_c('FormulateSchema',{attrs:{"schema":_vm.hiddenElements}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }